import * as React from 'react'

import { UserIcon } from 'lucide-react'
import { inject, observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import MobileInitialState from '~/client/src/mobile/stores/MobileInitialState'
import LanguageSelector from '~/client/src/shared/components/LanguageSelector/LanguageSelector'
import { QRCode } from '~/client/src/shared/components/LazyQRCode'
import config from '~/client/src/shared/Config'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { getUserScanCode } from '~/client/src/shared/models/Scanner'
import ProjectsStore from '~/client/src/shared/stores/domain/Projects.store'
import ThemeMode from '~/client/src/shared/utils/ThemeModeManager'
import {
  EMPTY_STRING,
  QR_CODE_LOGO_SRC,
} from '~/client/src/shared/utils/usefulStrings'

import MobileEventStore from '../../stores/EventStore/MobileEvents.store'
import MobileCommonStore from '../../stores/ui/MobileCommon.store'
import SidebarFooter from './components/SidebarFooter/SidebarFooter'
import SidebarHeader from './components/SidebarHeader/SidebarHeader'
import SidebarItems from './components/SidebarItems'
import SidebarLogoutItem from './components/SidebarLogoutItem'
import SidebarStore from './Sidebar.store'

import Colors from '~/client/src/shared/theme.module.scss'
import './Sidebar.scss'

const QR_CODE_TO_PRINT_SIZE = 200

interface ISidebar {
  common?: MobileCommonStore
  state?: MobileInitialState
  eventsStore?: MobileEventStore
  projectsStore?: ProjectsStore
}

@inject('common', 'state', 'eventsStore', 'projectsStore')
@observer
export default class Sidebar extends React.Component<ISidebar> {
  private readonly sidebarStore: SidebarStore

  public constructor(props: ISidebar) {
    super(props)

    this.sidebarStore = new SidebarStore(
      props.common,
      props.eventsStore,
      props.state,
      props.projectsStore,
    )
  }

  public render() {
    const { isSidebarOpened, sidebarItems, onClickHandler, logoutHandler } =
      this.sidebarStore

    return (
      <div
        className={classList({
          'sidebar scrollable': true,
          opened: isSidebarOpened,
          closed: !isSidebarOpened,
        })}
      >
        <SidebarHeader
          projects={this.sidebarStore.projects}
          activeProject={this.sidebarStore.activeProject}
          onSelectProject={this.sidebarStore.selectProject}
        />
        {Localization.shouldShowLanguageSelector && (
          <LanguageSelector
            textSize="header"
            className="mx20 my10 primary-blue"
          />
        )}
        <div className="col">
          {this.renderQRCode()}
          <SidebarItems onClickHandler={onClickHandler} items={sidebarItems} />
          <SidebarLogoutItem onClick={logoutHandler} />
        </div>
        <SidebarFooter config={config} />
      </div>
    )
  }

  private renderQRCode() {
    return (
      <div className="qr-code-container col x-center y-center">
        <div className="col x-center">
          <QRCode
            value={this.userQRValue}
            logoImage={QR_CODE_LOGO_SRC}
            size={QR_CODE_TO_PRINT_SIZE}
            fgColor={ThemeMode.getHEXColor(Colors.neutral0)}
          />
          <div className="row x-center text extra-large">
            <UserIcon size={20} className="tw:flex-none! tw:mr-1" />
            {this.props.state?.user?.fullName}
          </div>
        </div>
      </div>
    )
  }

  private get userQRValue(): string {
    const user = this.props.state?.user
    return user ? getUserScanCode(user) : EMPTY_STRING
  }
}
